// Shared OTP constants + hashing used by the client wrapper and (mirrored,
// see comment below) by the Edge Functions.
//
// TODO(post-V1): replace OTP stub with real SMS provider (Twilio / MSG91).
// Until then every code is '1234'; only the hashing scheme matters here.

/** Mirror of v_max_attempts in supabase/migrations/202606071200_otp_verifications.sql */
export const OTP_MAX_ATTEMPTS = 5;

/** Mirror of p_ttl_seconds default in issue_otp(). */
export const OTP_TTL_SECONDS = 600;

/** Dev-only constant. When SMS goes live this disappears entirely. */
export const OTP_DEFAULT_DEV = '1234';

/**
 * SHA-256 hex digest of `code`. Uses the Web Crypto API so the same
 * function runs in the browser (vitest/jsdom) and in Deno (Edge Functions).
 */
export async function hashCode(code: string): Promise<string> {
  const bytes = new TextEncoder().encode(code);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
